var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleArrow = function SvgDoubleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.91.91a.833.833 0 0 1 1.179 0l3.333 3.333a.833.833 0 0 1 0 1.179L10.09 8.755A.833.833 0 0 1 8.91 7.577l1.91-1.911H1.166a.833.833 0 0 1 0-1.667h9.655l-1.91-1.91a.833.833 0 0 1 0-1.179M5.09 9.243a.833.833 0 0 1 0 1.179l-1.911 1.91h9.655a.833.833 0 0 1 0 1.667H3.178l1.91 1.911a.833.833 0 0 1-1.177 1.178L.577 13.755a.833.833 0 0 1 0-1.178l3.334-3.334a.833.833 0 0 1 1.178 0"
  })));
};
export default SvgDoubleArrow;